var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBhsIcone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 311.82 251.91",
    role: "img",
    "aria-label": "BHS",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00ac22",
    d: "M311.82,33.93h-168.51l-9.82,55.5h112.31l-18.47,107.75h-55.73l-9.28,54.73,112.08-.31,37.41-217.67h.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1ce766",
    d: "M0,217.98h168.43l9.89-55.5-112.39.23,18.55-107.99h55.73L149.49,0,37.41.31,0,217.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBhsIcone);
export default __webpack_public_path__ + "static/media/logo-bhs-icone.83c0ccab02d4b81d8082c25fa4548a19.svg";
export { ForwardRef as ReactComponent };